/**
 * @description: 经理打折报表
 * @author: hwx
 * @update: lyr
*/
<template>
    <div class="jld-report">
        <div class="jld-list" v-show="!showJldBill">
            <div class="row row-margin">
                <label class="list-label-2">时间:</label>
                <div class="col-md-3 list-time">
                    <div ref="jldTime">
                        <input type="text" class="form-control laydate-icon" v-model="jldStartTime"> -
                        <input type="text" class="form-control laydate-icon" v-model="jldEndTime">
                    </div>
                </div>
                <label class="list-label-2">门店:</label>
                <div class="col-md-2 ct-col">
                    <select class="form-control" ref="jldShop" data-placeholder="请选择门店"></select>
                </div>
                <div class="col-md-1 ct-col jh-tit-sel">
                    <select class="form-control" ref="jldperf_tit_sel">
                        <option value="room_name">包厢号</option>
                        <option value="bill_no">单据编号</option>
                    </select>
                </div>
                <div class="col-md-2 jh-con-val">
                    <input type="text" class="form-control" v-model="jldperf_con_val" :placeholder="jldperf_con_phd">
                </div>
                <div>
                    <button type="button" class="btn btn-flat btn-small btn-orange" @click="getJldList(1)" style="margin-right: 10px">查询</button>
                    <button type="button" class="btn btn-flat btn-small btn-border-gray" @click="getJldExportSet">导出</button>
                </div>
            </div>
            <el-table
                v-loading="loading"
                element-loading-text="努力加载中，请稍后..."
                element-loading-background="rgba(0, 0, 0, 0.6)"
                :data="jld_list_table">
                <el-table-column type="index" label="行号"></el-table-column>
                <el-table-column prop="room_name" label="包厢号"></el-table-column>
                <el-table-column prop="start_time" label="下单时间"></el-table-column>
                <el-table-column label="单据编号">
                    <template slot-scope="scope">
						<span class="text-blue" @click="jldDetail(scope.row.bill_no)">{{scope.row.bill_no}}</span>
					</template>
                </el-table-column>
                <el-table-column prop="manager_name" label="经理姓名"></el-table-column>
                <el-table-column prop="prime_unpaid_amount" label="单据实收金额"></el-table-column>
                <el-table-column prop="manager_discount" label="经理打折额度"></el-table-column>
                <el-table-column prop="discount_amount" label="经理打折金额"></el-table-column>
                <el-table-column prop="unpaid_amount" label="折后金额"></el-table-column>
            </el-table>
            <div class="pagination-row">
                <div>
                    <label class="list-label-6">经理打折小计:</label>
                    <div class="list-total">{{jld_discount_amount_total}}</div>
                    <label class="list-label-4">折后小计:</label>
                    <div class="list-total">{{jld_unpaid_amount_total}}</div>
                </div>
                <el-pagination
                    background
                    layout="total, prev, pager, next, jumper"
                    :page-size="GLOBAL.PAGESIZE"
                    :current-page.sync="jld_list_page"
                    :total="jld_list_total"
                    @current-change="getJldList">
                </el-pagination>
            </div>
            <!-- 导出设置弹窗 -->
            <div class="ele-hide" ref="jldExport_alert">
                <div class="set-export sel-seldiv">
                    <h3>请选择导出报表需要的显示的字段</h3>
                    <ul class="set-area clearfix">
                        <li>
                            <input type='checkbox' v-model='jldExport_allcheck' @click='jldExportCheckedAll'>
                            <label>全选</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='jldExport_checkModel' value="room_name">
                            <label>包厢号</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='jldExport_checkModel' value="start_time">
                            <label>下单时间</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='jldExport_checkModel' value="bill_no">
                            <label>单据编号</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='jldExport_checkModel' value="manager_name">
                            <label>经理姓名</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='jldExport_checkModel' value="prime_unpaid_amount">
                            <label>单据实收金额</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='jldExport_checkModel' value="manager_discount">
                            <label>经理打折额度</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='jldExport_checkModel' value="discount_amount">
                            <label>经理打折金额</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='jldExport_checkModel' value="unpaid_amount">
                            <label>折后金额</label>
                        </li>
                    </ul>
                    <h3>请选择导出报表的文件格式</h3>
                    <ul class="clearfix">
                        <li>
                            <input type="radio" v-model='jldExport_type' value="1">
                            <label>excel表格</label>
                        </li>
                        <li>
                            <input type="radio" v-model='jldExport_type' value="2">
                            <label>pdf文件</label>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
        <div class="jld-bill" v-show="showJldBill">
            <billDetail ref="jld_bill_det" @backBdwPre="showJldBill = false"></billDetail>
        </div>
    </div>
</template>
<script>
    import Vue from 'vue';
    import billDetail from '@/components/bill_detail.vue';
    export default {
        name: '',
        data() {
            return {
                loading: false,
                showJldBill: false,
                jldStartTime: "",
                jldEndTime: "",
                jldperf_field: "room_name",
                jldperf_con_phd: "请输入包厢号",
                jldperf_con_val: "",
                jld_list_table: [],
				jld_list_page: 1,
                jld_list_total: 0,
                jld_discount_amount_total: '',
                jld_unpaid_amount_total: '',
                jldExport_allcheck: false,
                c_jldExport_allcheck: false,
                jldExport_checkModel: [],
                jldExport_checkData: ['room_name', 'start_time', 'bill_no', 'manager_name', 'prime_unpaid_amount', 'manager_discount', 'discount_amount', 'unpaid_amount'],
                jldExport_type: 1,
            }
        },
        components: {
            "billDetail": billDetail
        },
        watch: {
            jldExport_checkModel: {
                handler: function(val, oldVal) {
                    if(this.jldExport_checkModel.length >= this.jldExport_checkData.length) {
                        this.jldExport_allcheck = true;
                        this.c_jldExport_allcheck = true;
                    } else {
                        this.jldExport_allcheck = false;
                        this.c_jldExport_allcheck = false;
                    }
                },
                deep: true
            },
        },
        mounted: function() {
            const _this = this
            // 日期
            _this.jldStartTime = moment().hour(8).minute(0).format('YYYY-MM-DD HH:mm');
            _this.jldEndTime = moment().add(1, 'day').hour(8).minute(0).format('YYYY-MM-DD HH:mm');
            _this.innitDate(); // 日期
            _this.shopDatas = [];
            _this.innitInput();  // 门店
            // 下拉选项
            $(_this.$refs.jldperf_tit_sel).select2({
                language: "zh-CN",
                minimumResultsForSearch: -1,
                width: '100%'
            }).change(function() {
                _this.jldperf_field = $(this).val();
                if(_this.jldperf_field == 'room_name') {
                    _this.jldperf_con_phd = '请输入包厢号';
                } else if(_this.jldperf_field == 'bill_no') {
                    _this.jldperf_con_phd = '请输入单据编号';
                }
            });
        },
        methods: {
            setShopDefaultTime(shop_id) {
                let report_default_time = '1'
                let shop_report_default_time = this.$store.state.shop_report_default_time
                shop_report_default_time.forEach(item => {
                    if (shop_id == item.shop_id) {
                        report_default_time = item.report_default_time
                        if (report_default_time == '1') {
                            this.jldStartTime = moment().hour(8).minute(0).format('YYYY-MM-DD HH:mm');
                            this.jldEndTime = moment().add(1, 'day').hour(8).minute(0).format('YYYY-MM-DD HH:mm');
                        }else {
                            this.jldStartTime = moment().subtract(1, 'day').hour(8).minute(0).format('YYYY-MM-DD HH:mm');
                            this.jldEndTime = moment().hour(8).minute(0).format('YYYY-MM-DD HH:mm');
                        }
                    }
                })
            },
            // 初始化日期插件
            innitDate: function() {
                let _this = this;
                $(_this.$refs.jldTime).daterangepicker({
                    timePicker: true,
                    timePickerIncrement: 1,
                    timePicker12Hour: false,
                    buttonClasses: ['btn btn-default'],
                    applyClass: 'btn-small btn-orange',
                    cancelClass: 'btn-small btn-gray',
                    startDate: moment().hour(8).minute(0).toDate(),
                    endDate: moment().add(1, 'day').hour(8).minute(0).toDate(),
                    maxDate: moment().add(1, 'day').hour(8).minute(0).toDate(),
                    dateLimit: {
                        days: 31
                    },
                }, function(start, end, label) {
                    _this.jldStartTime = start.format('YYYY-MM-DD HH:mm');
                    _this.jldEndTime = end.format('YYYY-MM-DD HH:mm');
                });
            },
            // 初始化门店输入框
            innitInput: function() {
                let _this = this;

                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "page": "1",
                            "page_size": "0",
                            "name": "",
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "PublicData/api_getShopListByPurview",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: {
                        json: datas2
                    },
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            $.each(data.response.result, function(k, v) {
                                if (v.id != '0') {
                                    _this.shopDatas.push({
                                        id: v.id,
                                        text: v.name
                                    });
                                }
                            });
                            $(_this.$refs.jldShop).select2({
                                data: _this.shopDatas,
                                allowClear: true,
                                minimumResultsForSearch: -1,
                                language: "zh-CN"
                            }).on("select2:select", function(e) {
                                _this.setShopDefaultTime( e.params.data.id)
                            });
                            $(_this.$refs.jldShop).val(data.response.result[1].id).trigger('change');
                            _this.setShopDefaultTime(data.response.result[1].id)
                            _this.getJldList(1);
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data.response.error_msg);
                        }
                    },
                    error: function(err) {
                        layer.msg("出错啦");
                    }
                });
            },



            getJldList(page) {
				const _this = this;

                _this.loading = true;
                _this.jld_list_page = page
                let room_name = '',
                    bill_no = '';
                if(_this.jldperf_field == 'room_name') {
                    room_name = _this.jldperf_con_val;
                } else if(_this.jldperf_field == 'bill_no') {
                    bill_no = _this.jldperf_con_val;
                }
				Vue.axios.post('FinanceReport2/getManagerDiscountReport', {
					"header": Vue.request_header,
					"request": {
						"param": {
							"page": page,
							"page_size": _this.GLOBAL.PAGESIZE,
                            "start_time": _this.jldStartTime,
                            "end_time": _this.jldEndTime,
                            "shop_id": $(_this.$refs.jldShop).val(),
                            "room_name": room_name,
                            "bill_no": bill_no,
						}
					},
					"comment": ""
				})
				.then(res => {
					if(res.data.response.result_code == "true") {
						if(page == 1) {
							_this.jld_list_total = Number(res.data.response.result.total);
							_this.jld_discount_amount_total = res.data.response.result.discount_amount_total;
							_this.jld_unpaid_amount_total = res.data.response.result.unpaid_amount_total;
						}
						_this.jld_list_table = res.data.response.result.rows;
						_this.loading = false;
					} else {
						Vue.timeoutfun(res.data.response.result_status, _this);
						layer.msg(res.data.response.error_msg);
					}
				})
				.catch(err => {
					layer.msg("出错啦");
				});
			},
            jldDetail(bill_no) {
                this.$refs.jld_bill_det.getBdwDetail(bill_no);
                this.showJldBill = true;
            },
            // 获取导出设置
            getJldExportSet: function() {
                let _this = this;
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "report_type": "FinanceReport2/managerDiscountExport"
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "FinanceReport/getExportSet",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: {
                        json: datas2
                    },
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            if(data.response.result) {
                                _this.jldExport_checkModel = data.response.result.export_fields;
                                _this.jldExport_type = data.response.result.export_type;
                            } else {
                                _this.jldExport_checkModel = _this.jldExport_checkData;
                                _this.jldExport_type = 1;
                            }
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data.response.error_msg);
                        }
                    },
                    error: function(err) {
                        layer.msg("出错啦");
                    }
                });

                // 弹窗
                layer.confirm('', {
                    skin: 'add_printer_area',
                    type: 1,
                    btn: ['确定', '取消'], // 按钮
                    title: ['导出设置', true],
                    area: ['830px', ''], // 宽高
                    content: $(_this.$refs.jldExport_alert)
                }, function() {
                    _this.exportJldList();
                });
            },
            // 导出字段全选
            jldExportCheckedAll: function() {
                let _this = this;
                _this.jldExport_allcheck = _this.c_jldExport_allcheck;
                if(!_this.jldExport_allcheck) { // 实现全选
                    _this.jldExport_checkModel = [];
                    _this.jldExport_checkData.forEach(function(item) {
                        _this.jldExport_checkModel.push(item);
                    });
                } else { // 实现反选
                    _this.jldExport_checkModel = [];
                }
            },
            // 导出经理打折报表
            exportJldList: function() {
                let _this = this,
                    shop_id = $(_this.$refs.jldShop).val();
                let export_fields = JSON.stringify(_this.jldExport_checkModel);
                let room_name = '',
                    bill_no = '';
                if(_this.jldperf_field == 'room_name') {
                    room_name = _this.jldperf_con_val;
                } else if(_this.jldperf_field == 'bill_no') {
                    bill_no = _this.jldperf_con_val;
                }
                window.location.href = Vue.ctUrl + "FinanceReport2/managerDiscountExport?" +
                    "&start_time=" + _this.jldStartTime +
                    "&end_time=" + _this.jldEndTime +
                    "&shop_id=" + shop_id +
                    "&room_name=" + room_name +
                    "&bill_no=" + bill_no +
                    "&export_fields=" + export_fields +
                    "&export_type=" + _this.jldExport_type;
                // debugger;
                layer.msg("导出成功！");
                layer.closeAll();
            },
        }
    }
</script>
<style lang="less" scoped>
    .jld-list {
        table {
            word-wrap: break-word;
        }
    }
</style>